import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    createTransaction,
    deleteTransaction,
    getTransactions,
    updateTransaction,
} from "./transactionAPI";

export const fetchTransactions = createAsyncThunk(
    "transaction/fetchTransactions",
    async () => {
        const response = await getTransactions();
        return {
            data: response.data,
        };
    }
);

export const fetchPaginationTransactions = createAsyncThunk(
    "transaction/fetchTransactions",
    async ({ currentPage, limit, type, find }) => {
        const response = await getTransactions(currentPage, limit, type, find);
        return {
            data: response.data,
            transactionsLength: response.headers["x-total-count"],
        };
    }
);

export const addTransaction = createAsyncThunk(
    "transaction/addTransaction",
    async (data) => {
        const response = await createTransaction(data);
        return response;
    }
);

export const changeTransaction = createAsyncThunk(
    "transaction/changeTransaction",
    async ({ id, data }) => {
        const response = await updateTransaction(id, data);
        return response;
    }
);

export const removeTransaction = createAsyncThunk(
    "transaction/removeTransaction",
    async (id) => {
        const response = await deleteTransaction(id);
        return response;
    }
);

const initialState = {
    transactions: [],
    transaction: {},
    isLoading: false,
    isError: false,
    error: "",
};

export const transactionSlice = createSlice({
    name: "transaction",
    initialState,
    reducers: {
        editTransaction: (state, action) => {
            state.transaction = action.payload;
        },
        emptyTransaction: (state) => {
            state.transaction = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTransactions.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(fetchTransactions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.transactions = action.payload.data;
            })
            .addCase(fetchTransactions.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error.message;
                state.transactions = [];
            })
            .addCase(addTransaction.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(addTransaction.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.transactions.push(action.payload);
            })
            .addCase(addTransaction.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error.message;
                state.transactions = [];
            })
            .addCase(changeTransaction.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(changeTransaction.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                const index = state.transactions.findIndex(
                    (t) => t.id === action.meta.arg.id
                );
                state.transactions[index] = action.payload;
            })
            .addCase(changeTransaction.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error.message;
                state.transactions = [];
            })
            .addCase(removeTransaction.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(removeTransaction.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.transactions = state.transactions.filter(
                    (t) => t.id !== action.meta.arg
                );
            })
            .addCase(removeTransaction.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error.message;
                state.transactions = [];
            });
    },
});

export const { editTransaction, emptyTransaction } = transactionSlice.actions;
export default transactionSlice.reducer;
